"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentPubnubChannel = exports.ShipmentPubnubChannelPrefix = void 0;
var ShipmentPubnubChannelPrefix;
(function (ShipmentPubnubChannelPrefix) {
    ShipmentPubnubChannelPrefix["Shipment"] = "shipment";
})(ShipmentPubnubChannelPrefix = exports.ShipmentPubnubChannelPrefix || (exports.ShipmentPubnubChannelPrefix = {}));
var ShipmentPubnubChannel;
(function (ShipmentPubnubChannel) {
    ShipmentPubnubChannel["BucketChanged"] = "bucket-changed";
    ShipmentPubnubChannel["Created"] = "created";
    ShipmentPubnubChannel["Deleted"] = "deleted";
    ShipmentPubnubChannel["Updated"] = "updated";
})(ShipmentPubnubChannel = exports.ShipmentPubnubChannel || (exports.ShipmentPubnubChannel = {}));
//# sourceMappingURL=ShipmentPubnubChannels.js.map